export default __webpack_public_path__ + "static/media/a023-startup2-short.0fdbe4eb.png";